/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { loadingActualDetailConfig } from '../../config/loading.config';
export interface IStaticActualDetailPluginMethods extends IPluginMethodMap {
  getStaticActualDetailSync(args?: any): any;
}

export class StaticActualDetailPlugin implements IAgentPlugin {
  readonly methods: IStaticActualDetailPluginMethods;

  constructor() {
    this.methods = {
      getStaticActualDetailSync: this.getStaticActualDetailSync.bind(this),
    };
  }

  getStaticActualDetailSync(args?: any) {
    return {
      loading: loadingActualDetailConfig?.loading,
    };
  }
}
